import React from "react";
import styles from "./BlogPage.module.css";
import Margin from "../Margin";
import blogPosts from "./blogPosts.json";
import LanguageSwitch from "./LanguageSwitch";
import { labels, localizePost } from "./blogLanguage";

const BlogPage = ({ language, onLanguageChange }) => {
  return (
    <main className={styles.page} lang={language}>
      <a href="#/" className={styles.backButton}>{labels[language].home}</a>
      <section className={styles.inner}>
        <Margin size={4} />
        <LanguageSwitch language={language} onLanguageChange={onLanguageChange} />
        <h1 className={styles.title}>{labels[language].blog}</h1>
        <ul className={styles.entryList}>
          {blogPosts.map((entry, i) => ({ ...localizePost(entry, language), creationIndex: i })).sort((a, b) => new Date(b.date) - new Date(a.date)).map((entry) => (
            <li key={entry.slug} className={styles.entryItem}>
              <a href={`#/blog/${entry.slug}`} className={styles.entryLink}>
                <span className={styles.entryId}>{String(entry.creationIndex + 1).padStart(2, "0")}</span>
                <span className={styles.entryTitle}>{entry.title}</span>
                <span className={styles.entryDate}>{entry.date}</span>
              </a>
            </li>
          ))}
        </ul>
      </section>
    </main>
  );
};

export default BlogPage;
